import React from 'react';
import { motion } from 'framer-motion';

interface TableScreenProps {
  children: React.ReactNode;
}

export default function TableScreen({ children }: TableScreenProps): JSX.Element {
  return (
    <motion.div
      className="table-screen-shell"
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      {children}
    </motion.div>
  );
}
